/*
 * THG reviews scroll fix.
 *
 * The star rating on PDPs is <div onclick="scrollToReviews()">. The theme's
 * inline scrollToReviews() does a single smooth scrollIntoView. Problem:
 * product-recommendations and recently-viewed-products sit ABOVE the reviews
 * and lazy-load via IntersectionObserver — they fetch on a network delay and
 * render in AFTER the scroll, growing the page and shoving reviews back down.
 *
 * Fix, in two parts:
 *   1. PRELOAD those sections quietly in the background a moment after page
 *      load, so they're already rendered before the user ever clicks.
 *   2. On click, if anything is still pending, force-load + wait; otherwise
 *      it's an instant smooth scroll into a final layout.
 *
 * Loaded with `defer`, so this overrides the theme's inline scrollToReviews.
 */
(function () {
  var REVIEWS_ID = 'judgeme_product_reviews';
  var LAZY_SEL = 'product-recommendations, recently-viewed-products';

  function smoothTo(target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function isEmpty(el) {
    return el.childElementCount === 0;
  }

  // Trigger an element's own lazy-load without scrolling to it.
  function forceLoad(el) {
    try {
      if (typeof el.handleIntersection === 'function') {
        el.handleIntersection([{ isIntersecting: true }], { unobserve: function () {} });
        return true;
      }
    } catch (e) {}
    return false;
  }

  // --- Part 1: background preload -------------------------------------------
  var preloaded = false;
  function preload(attempt) {
    if (preloaded) return;
    var pending = Array.prototype.slice
      .call(document.querySelectorAll(LAZY_SEL))
      .filter(isEmpty);
    if (!pending.length) { preloaded = true; return; }

    var triggeredAny = false;
    pending.forEach(function (el) { if (forceLoad(el)) triggeredAny = true; });

    // Custom elements may not be upgraded yet — retry a few times.
    if (!triggeredAny && (attempt || 0) < 10) {
      setTimeout(function () { preload((attempt || 0) + 1); }, 300);
    } else {
      preloaded = true;
    }
  }

  function schedulePreload() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { preload(0); }, { timeout: 2000 });
    } else {
      setTimeout(function () { preload(0); }, 1200);
    }
  }

  if (document.readyState === 'complete') {
    schedulePreload();
  } else {
    window.addEventListener('load', schedulePreload);
  }

  // --- Part 2: the click handler --------------------------------------------
  function scrollToReviews() {
    var target = document.getElementById(REVIEWS_ID);
    if (!target) return;

    var pending = Array.prototype.slice
      .call(document.querySelectorAll(LAZY_SEL))
      .filter(isEmpty);

    // Preload already finished (the common case) → instant smooth scroll.
    if (!pending.length) {
      smoothTo(target);
      return;
    }

    // Clicked before preload finished — trigger now and wait briefly.
    var triggeredAll = true;
    pending.forEach(function (el) { if (!forceLoad(el)) triggeredAll = false; });
    if (!triggeredAll) window.scrollTo(0, document.body.scrollHeight);

    var deadline = Date.now() + 2500;
    var poll = setInterval(function () {
      if (!pending.some(isEmpty) || Date.now() > deadline) {
        clearInterval(poll);
        setTimeout(function () { smoothTo(target); }, 100);
      }
    }, 50);
  }

  window.scrollToReviews = scrollToReviews;
})();
